import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import createDOMPurify from "dompurify";

import type { AnchorNotificationProps } from "../../types";

const DOMPurify = createDOMPurify(globalThis);

const AnchorNotification = ({ text }: AnchorNotificationProps) => {
  const navigate = useNavigate();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const anchors = container.getElementsByTagName("a");
    const handlers: { el: HTMLAnchorElement; fn: (e: Event) => void }[] = [];

    for (const anchor of Array.from(anchors)) {
      const handler = (e: Event) => {
        e.preventDefault();
        const href = anchor.getAttribute("href");
        if (href) navigate(href);
      };
      anchor.addEventListener("click", handler);
      handlers.push({ el: anchor, fn: handler });
    }

    return () => {
      handlers.forEach(({ el, fn }) => el.removeEventListener("click", fn));
    };
  }, [navigate, text]);

  return (
    <div
      ref={containerRef}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(text, {
          USE_PROFILES: { html: true },
        }),
      }}
    />
  );
};

export default AnchorNotification;
